import * as React from "react";
import { IUser } from "src/api/types";
import { ThemeOptions } from "@material-ui/core/styles/createTheme";

export interface IAppContextProps {
  appContext: IAppContext;
}

export default function <P>(
  Component: React.ComponentType<IAppContextProps & P>
) {
  return (props: P) => {
    return (
      <AppContextConsumer>
        {(appContext) => {
          return <Component {...props} appContext={appContext} />;
        }}
      </AppContextConsumer>
    );
  };
}

export interface IAppContext {
  // The base URI excluding the forwardslash.
  baseUri: string;
  user: IUser;
  userChanged: (user: IUser) => void;
  userLogout: () => void;
  setTheme: (theme: ThemeOptions) => void;
  loadingUserInitial: boolean;
  changeIsNewUser: (value:any) => void;
  isNewUser:boolean,
  onChangeUserDetails: (value:any) => void;
  newUserDetails:any,
  getNewLoginUserDetails:()=>void
  removeNewUserDetails:()=>void
}

export const AppContext = React.createContext<IAppContext>({} as any);
export const AppContextConsumer = AppContext.Consumer;



// WEBPACK FOOTER //
// ./src/shared/components/withAppContext.tsx